
<!------------------------------------------------------------->

<div id="wrapper">
  <div class="nav-map" *ngIf="withOption">
    @if(isOnMobile){
    <div class="top-wrapper">
      <div class="position-relative">
        <input [(ngModel)]="params.search" class="form-control" [ngModelOptions]="{ standalone: true }"
          placeholder="Input Keyword" (keyup.enter)="geocodePostalCode()"  (keydown)="getSearchSuggestions($event)" />
        <!-- <input [(ngModel)]="params.postalCode" class="form-control mt-2"  placeholder="Enter Postal Code" />

        <select class="form-control form-select mt-2" (change)="handleZoom()" [(ngModel)]="params.radius">
          <option value="0" selected disabled>Radius</option>
          <option *ngFor="let radius of [0.2, 1, 2, 5, 10, 20, 'All']" [value]="radius">
            {{ radius == 'All' ? 'All' : radius < 1 ? radius * 1000 + "m" : radius + "km" }} </option>
        </select> -->

        <div class="position-absolute" style="top: calc(100% + .2rem); width: 100vw; z-index: 1000;">
          <!-- <div *ngTemplateOutlet="searchSuggestionstemp"></div> -->
          <app-search-suggestion [searchSuggestions]="searchSuggestions" (suggestionClicked)="openSuggestionText($event)"></app-search-suggestion>
        </div>
      </div>
      <div>
        <button class="search" (click)="geocodePostalCode()" id="btnSearchGmap">
          <i class="fa-solid fa-search"></i>
        </button>
      </div>
     <!-- <button class="btn btn-sm btn-dark" (click)="openSelectRegion()">Region Search</button> -->

    </div>

    }@else{

    <div class="position-relative">
      <label for="">Search Name</label>
      <input [(ngModel)]="params.search" class="form-control" [ngModelOptions]="{ standalone: true }"
        placeholder="Input Keyword" (keyup.enter)="geocodePostalCode()"   (keydown)="getSearchSuggestions($event)"/>
        <div class="position-absolute" style="top: calc(100% + .2rem); width: 100vw; z-index: 1000;">
          <!-- <div *ngTemplateOutlet="searchSuggestionstemp"></div> -->
          <app-search-suggestion [searchSuggestions]="searchSuggestions" (suggestionClicked)="openSuggestionText($event)"></app-search-suggestion>
        </div>
    </div>
    <div>
      <label for="">Postal</label>
      <input [(ngModel)]="params.postalCode" class="form-control" ngDefaultControl placeholder="Enter Postalcode" />
    </div>
    <div>
      <label for="">Radius</label>
      <select class="form-control form-select" (change)="handleZoom()" [(ngModel)]="params.radius">
        <option value="0" selected disabled>Radius</option>
        <option *ngFor="let radius of [0.2, 1, 2, 5, 10, 20, 'All']" [value]="radius">
          {{ radius == 'All' ? 'All' : radius < 1 ? radius * 1000 + "m" : radius + "km" }} </option>
      </select>
    </div>
    <div>
      <button class="search" (click)="geocodePostalCode()" id="btnSearchGmap">
        <i class="fa-solid fa-search"></i>
      </button>
    </div>
  


    }
   


  </div>
    
    <button  id="regionSearchBtn" class="btn btn-sm btn-dark d-none" (click)="openSelectRegion()">Region Search</button>
 
    <div class="w-100 d-flex flex-wrap" style="gap: .5rem">
      <button class="btn btn-sm btn-outline-secondary" *ngFor="let sub of selectedSubRegions">
        {{sub.name}}
        <button class="mr-2 t-btn" (click)="$event.stopPropagation(); removeSub(sub)">
          <i class="fa fa-x"></i>
        </button>
      </button>

    </div>

  <!-- Start of Selection -->
  <!-- <button class="btn btn-secondary w-100 mb-2 d-block d-md-none" (click)="showMap = !showMap" *ngIf="isOnMobile">
    <i [ngClass]="showMap ? 'fa-solid fa-chevron-up' : 'fa-solid fa-chevron-down'"></i>
    {{ showMap ? 'Hide Maps' : 'Show Maps' }}
  </button> -->


  <div class="map-params my-2" [ngClass]="{ 'd-none d-md-block': !showMap }" *ngIf="isOnMobile">
    <div>
      <label for="">Postal</label>
      <input [(ngModel)]="params.postalCode" class="form-control" ngDefaultControl placeholder="Enter Postalcode" />
    </div>
    <div>
      <label for="">Radius</label>
      <select class="form-control form-select" (change)="handleZoom()" [(ngModel)]="params.radius">
        <option value="0" selected disabled>Radius</option>
        <option *ngFor="let radius of [0.2, 1, 2, 5, 10, 20, 'All']" [value]="radius">
          {{ radius == 'All' ? 'All' : radius < 1 ? radius * 1000 + "m" : radius + "km" }} </option>
      </select>
    </div>
  </div>



  <!-- End of Selection -->

  <!-- Start of Selection -->
  <!-- Start of Selection -->

  <!-- <div id="map" [ngClass]="{ 'd-none d-md-block': !showMap }"></div> -->
</div>